import { Link } from "react-router-dom";
import { Plane } from "lucide-react";
import { AUTH_IMG } from "@/lib/api";

export default function AuthLayout({ children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-950" data-testid="auth-page">
      <div className="hidden lg:flex relative overflow-hidden">
        <img src={AUTH_IMG} alt="Empty airport terminal" className="absolute inset-0 w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" />
        <div className="relative z-10 mt-auto p-16 max-w-lg">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-blue-400 mb-4">Geneza Solutions · Travel SOP</p>
          <h2 className="font-cabinet font-bold text-4xl text-white leading-tight">Rehearse the counter before you reach it.</h2>
          <p className="mt-4 text-slate-400">Sign up with your Gmail to start practising with Officer Fredo Quist.</p>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center p-6 gap-8">
        <Link to="/" className="flex items-center gap-2 text-white font-cabinet font-bold text-lg" data-testid="auth-home-link">
          <Plane className="w-5 h-5 text-blue-500" /> E-immigration Practice Tool
        </Link>
        {children}
      </div>
    </div>
  );
}
